<template>
  <div>
    <div v-if="dataList" class="row">
      <div v-for="(obj, index) in dataList" :key="index" class="nx-card pt-1 col-md-4" @click="goDetails(obj)">
        <div class="nx-card-block cursor-pointer">
          <b-avatar class="mr-3" size="5rem" style="float: left;">
            <i v-if="obj.pessoa.tipoPessoa === 'PF'" style="font-size: 2rem" class="far fa-user"></i>
            <i v-else style="font-size: 2rem" class="far fa-building"></i>
          </b-avatar>
          <div><strong style="font-size: 16px;">{{obj.pessoa.nomeAssociado}}</strong></div>
          <div v-if="obj.pessoa.tipoPessoa === 'PF' || obj.pessoa.tipoPessoa === 'FÍSICA' || obj.pessoa.tipoPessoa === 'FISICA'">CPF: {{getValueFormatted(obj.pessoa.document, 'PF')}}</div>
          <div v-else>CNPJ: {{getValueFormatted(obj.pessoa.document, 'PJ')}}</div>
          <div>Número Sisbr: {{obj.numSisbr}}</div>
          <div>PA: {{obj.pa && obj.pa.numero + ' - ' + obj.pa.descricao}}</div>
          <div>Gerente Sisbr: {{obj.gerenteSisBR && obj.gerenteSisBR.pessoa && obj.gerenteSisBR.pessoa && obj.gerenteSisBR.pessoa.nome}}</div>
          <div>{{$lang.RelationchipManager.Label}}: {{obj.gerenteRelacionamento && obj.gerenteRelacionamento.pessoa && obj.gerenteRelacionamento.pessoa && obj.gerenteRelacionamento.pessoa.nome}}</div>
        </div>
      </div>
    </div>
    <div v-else class="row">
        <div style="display: flex; justify-content: center; align-items: center; width: 100%; gap: .5rem;" v-if="associateData !== null">
          <i class="fas fa-exclamation-circle"></i><p style="margin: 0">Nenhum associado encontrado</p></div>
        <template v-else>
          <div v-for="(numb, index) in 12" :key="index" class="nx-card pt-1 col-md-4">
            <div class="nx-card-block">
              <div style="display: flex; justify-content: start; gap: 1rem;">
                <b-skeleton width="5rem" height="5rem" type="avatar"></b-skeleton>
                <div style="width: calc(100% - 5rem)">
                  <b-skeleton width="100%" height="15%"></b-skeleton>
                  <b-skeleton width="90%" height="15%"></b-skeleton>
                  <b-skeleton width="70%" height="10%"></b-skeleton>
                  <b-skeleton width="75%" height="10%"></b-skeleton>
                  <b-skeleton width="50%" height="10%"></b-skeleton>
                </div>
              </div>
            </div>
          </div>
        </template>
    </div>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'

export default {
  name: 'AssociateList',
  mixins: [ActionsForm],
  data () {
    return {
      associateData: null
    }
  },
  computed: {
    dataList () {
      let result = null
      if (this.associateData && this.associateData.totalElements > 0) {
        result = this.associateData.content
      }
      return result
    }
  },
  methods: {
    goDetails (obj) {
      this.$emit('edit', obj.id)
    },
    getInitialName (value) {
      return Tools.getInitialsOfName(value)
    },
    getValueFormatted (value, type) {
      return Tools.formatCpfCnpj(value, type)
    }
  }
}
</script>
<style scoped>
.title-line {
  width: 40px;
  height: 6px;
  margin: 37px 267px 9px 0px;
  border-radius: 3px;
  background-color: #707070;
}
.bg-crm {
  bottom: 59px;
  position: fixed;
  right: 27px;
}
.nx-card {
  cursor: pointer;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  background-color: #f5f5f5;
  border: 1px solid #cfd8dc;
  background-clip: border-box;
  /* border-radius: 0.25rem; */
}
.nx-card-block {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1.25rem;
}
</style>



// WEBPACK FOOTER //
// src/views/private/associate/components/associatelist.vue